module.exports = __webpack_public_path__ + "img/abajur-quarto.714f355f.png";